<template>
    <div class="h-screen flex justify-center items-center login-background">
        <div class="w-full max-w-sm px-2">

            <div class="logo mb-10">
                <img src="@/assets/logo.svg" />
            </div>

            <form class="px-8 pt-6 pb-8 mb-4"
            @submit="realizarRecovery">

                <div v-if="mensajeError != ''" class="bg-red text-white px-4 py-2 mb-4">
                    <strong>Ha ocurrido un error.</strong>
                    <span class="block sm:inline">{{ mensajeError }}</span>
                </div>

                <div v-if="mensajeExito != ''" class="bg-green-600 text-white px-4 py-2 mb-4">
                    <strong>Excelente.</strong>
                    <span class="block sm:inline">{{ mensajeExito }}</span>
                </div>


                <div class="text-azuloscuro text-2xl text-center leading-7 mb-10 font-semibold">
                    Introduce tu email y tu nueva contraseña.
                </div>


                <div class="mb-4">
                    <label class="block text-azulfondoclaro text-sm mb-2" for="form.email">
                        Email
                    </label>
                    <input class="appearance-none bg-transparent border-b-2 w-full pb-2 text-azuloscuro leading-tight"
                    type="text" placeholder="" v-model="form.email">
                </div>

                <div class="mb-6">
                    <label class="block text-azulfondoclaro text-sm mb-2" for="form.password1">Nueva Contraseña</label>
                    <div class="form-input w-full pr-8 focus-within:shadow-outline relative field-wrapper">
                        <input v-model="form.password1" :type="showPassword ? 'text' : 'password'" class="w-full bg-gray-100 outline-none" required>
                        <button type="button" class="cursor-pointer z-100 absolute right-0 top-0 bottom-0 my-2 mr-2" @click="toggleShowPassword()">
                            <Zondicon v-if="!showPassword" icon="view-show" class="fill-current inline-block mr-1 text-black loader" style="width: 24px"/>
                            <Zondicon v-else icon="view-hide" class="fill-current inline-block mr-1 text-black loader" style="width: 24px"/>
                        </button>
                    </div>
                </div>

                <div class="mb-6">
                    <label class="block text-azulfondoclaro text-sm mb-2" for="form.password2">Repite Contraseña</label>
                    <div class="form-input w-full pr-8 focus-within:shadow-outline relative field-wrapper">
                        <input v-model="form.password2" :type="showPassword ? 'text' : 'password'" class="w-full bg-gray-100 outline-none" required>
                        <div class="cursor-pointer z-100 absolute right-0 top-0 bottom-0 my-2 mr-2">
                            <Zondicon v-if="passwordsMatch" icon="checkmark" class="fill-current inline-block mr-1 text-green-700 loader" style="width: 24px"/>
                            <Zondicon v-else icon="close" class="fill-current inline-block mr-1 text-red loader" style="width: 24px"/>
                        </div>
                    </div>
                </div>

                <div class="flex justify-between mt-20">
                    <button class="bg-azuloscuro hover:bg-greenlight text-white py-2 px-4 rounded-full focus:outline-none w-full"
                    type="submit" :class="{ 'hidden': datosCargados == false }">
                        Enviar
                    </button>

                    <button class="bg-gray-600 mr-2 text-sm font-semibold text-white py-2 px-4 rounded-full w-full"
                    type="button" :class="{ 'hidden': datosCargados == true }">
                        Enviando datos...
                    </button>
                </div>

                <div class="flex justify-center items-center mt-6 text-center">
                    <router-link
                        to="/login"
                        class="block self-center text-sm text-blue-500 hover:text-blue-800">
                        Regresar al Login
                    </router-link>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
    import Utilities from '@/plugins/Utilities.js'
    import axios from 'axios'
    import auth from "@/plugins/api/users/auth";
    import Zondicon from "vue-zondicons";

    const Recovery = {
        name: 'Recovery',
        components: {
            Zondicon
        },
        data: function(){
            return {
                datosCargados: true,
                mensajeExito: '',
                mensajeError: '',
                form: {
                  email: '' ,
                  password1: '',
                  password2: '',
                  token: Math.random().toString(36).substr(2, 9)
                },
                email: '',
                showPassword: false,
            }
        },
        computed: {
            passwordsMatch () {
                return this.form.password === this.form.password2
            }
        },
        methods: {
            toggleShowPassword () {
                this.showPassword = !this.showPassword
            },
            realizarRecovery(e){
                e.preventDefault();
                this.datosCargados = true;
                this.mensajeExito = '';
                this.mensajeError = '';

                if( this.form.email != '' && this.form.password1 != '' && this.form.password2 != ''){
                    if(this.form.password1 !== this.form.password2){
                        this.mensajeError = "Las contraseñas no coinciden";
                    }else{
                        var ENDPOINT = auth.api.endpointPath.replace("api/v1/", "");
                        axios.post(ENDPOINT+'public-api/change-password-request', this.form).then(response => {
                            this.mensajeExito = 'Se ha enviado un email a tu dirección con las instrucciones.';
                            this.datosCargados = true;
                            this.form = {
                                email: '' ,
                                password1: '',
                                password2: '',
                                token: Math.random().toString(36).substr(2, 9)
                            };
                        });
                    }
                }
                else{
                    this.mensajeError = "Debe llenar correctamente todos los campos para poder ingresar al sistema"
                }
            }
        }
    }

    export default Recovery;
</script>

<style>
    .field-wrapper {
        height: 36px;
        border-bottom: 2px solid rgb(226, 232, 240);
    }
</style>
